import React from 'react'
import {
  Div,
  List,
  ListItem,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'
import { Button } from 'src/chrome'
import planContentStyles from '../PlanContentsGrid/planContentsGrid.module.scss'
import { PlansDescription } from 'src/marketing/plans/types'

type BasicPlanProps = {
  basicPlan?: PlansDescription
  onSelect: (planTitle: string) => void
}

const BasicPlan: React.FC<BasicPlanProps> = props => {
  const { basicPlan, onSelect } = props
  return (
    <Div
      className={`${planContentStyles.featureGridContainer} ${planContentStyles.offWhite}`}
    >
      <Div className={planContentStyles.featureGrid}>
        <Text type="subtitle" content="Or you can Pay As You Go!" />
        <Spacer space="x1" />
        <Text type="caption">
          Not ready to commit to a subscription? With a Pay As You Go Account,
          you can send cards for $2.75 a piece, plus postage! Once you try out
          our system, you can always upgrade later!
        </Text>
        <Spacer space="x1_5" />
        {basicPlan && (
          <List
            alignment="left"
            orientation="vertical"
            css={{ paddingLeft: '2em' }}
          >
            {basicPlan.description.details &&
              basicPlan.description.details.map((detail, index) => (
                <ListItem
                  key={`detail_${index}`}
                  orientation="horizontal"
                  css={{ listStyle: 'disc' }}
                >
                  {detail.innerDetails && (
                    <>
                      <Text type="footnote">{detail.detail}</Text>
                      <List alignment="left" orientation="vertical">
                        {detail.innerDetails.map((innerDetail, innerIndex) => (
                          <ListItem
                            orientation="horizontal"
                            key={`inner_detail_${innerIndex}`}
                            css={{ listStyle: 'circle', marginLeft: '1em' }}
                          >
                            <Text type="footnote">{innerDetail.detail}</Text>
                          </ListItem>
                        ))}
                      </List>
                    </>
                  )}
                  {!detail.innerDetails && (
                    <Text type="footnote">{detail.detail}</Text>
                  )}
                </ListItem>
              ))}
          </List>
        )}
        <Spacer space="x4" />
        {basicPlan ? (
          <Button title="Select" onClick={() => onSelect(basicPlan.id)} />
        ) : (
          <></>
        )}
      </Div>
    </Div>
  )
}

export default BasicPlan
